import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable, Subject, debounceTime, distinctUntilChanged, map, merge, mergeMap, of, switchMap } from 'rxjs';
import { SearchSelectService } from '../search-select.service';
import { ItemType } from '../search-select.component';
import { CreateItemComponent } from '../create-item/create-item.component';

@Component({
  selector: 'app-mobile-selection',
  templateUrl: './mobile-selection.component.html',
  styleUrls: ['./mobile-selection.component.scss'],
})
export class MobileSelectionComponent {
  items:ItemType[]|null = null;
  inputName:string | null | undefined = ''
  type:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {isMobile: boolean, type: 'city'|'school', selectedItem: ItemType|null, layer:number},
    private formBuilder: UntypedFormBuilder,
    private searchSelect: SearchSelectService,
    private dialog:MatDialog,
  ){}
  formGroup = this.formBuilder.group({
    control: new UntypedFormControl(),
  })
  ngOnInit(): void {
    this.getItemObs().subscribe()
    this.type = this.data.type
    if(this.data.selectedItem)
      this.formGroup.controls['control'].setValue(this.data.selectedItem.name)
  }
  getInputValue():Observable<string>{
    return this.formGroup.controls['control'].valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(300),
    )
  }
  getItemObs():Observable<any[]>{
    return this.getInputValue().pipe(
      switchMap((inputValue:string|null|undefined)=>{
        // if(inputValue=='' || inputValue==null || inputValue==undefined)
        //   return of([])
        // else
          return this.searchSelect.getItems(this.data.type, inputValue).pipe(
            map((response:any)=>response.results),
            map(((results:any[])=>{
              this.inputName = inputValue;
              return this.items = results;
            })),
          )
      }),
    )
  }
  canAdd():boolean{
    return this.items?.findIndex(i=>i.name==this.inputName) == -1 && this.data.type == 'school'
  }
}
